import BaseTemplate from "../src/layouts/BaseTemplate";
import MERDView from "../src/view/_public/MERDView";

export default function Merd() {
  return (
    <BaseTemplate
      title="Monitoring, Evaluation, and Research Department"
      body={<MERDView />}
    />
  );
}
